module.exports = __webpack_public_path__ + "img/hat05_uv_sleeve_down.d54b8535.svg";